import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.string.link.js";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import { makeStyles, useTheme, useMediaQuery, TextField } from "componentLibrary";
import { IconConstants } from "componentLibrary/MuiComponentWrappers/Icon/IconConstants";
import RaiseButton, { ButtonVariantEnum, ButtonSizeEnum } from "componentLibrary/MuiComponentWrappers/Button/RaiseButton";
import TextLink from "componentLibrary/TextLink/TextLink";
import MuiFormikField from "dashboard/Invoicing/common/MuiFormikField";
import { Form, Formik } from "formik";
import React from "react";
import { Link } from "react-router-dom";
import { WorkplaceOSLoginContainer, useWorkplaceOSLoginStyles, WorkplaceOSLoginHeader, WorkplaceOSLoginLabel, WorkplaceOSLoginError, WorkplaceOSLoginTerms } from "./WorkplaceOSLoginCommon";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var useStyles = function useStyles() {
  var theme = useTheme();
  return makeStyles(function () {
    return {
      containerContent: {
        display: "flex",
        flexDirection: "column"
      },
      containerContentItem: {
        gap: "4px",
        display: "flex",
        flexDirection: "column",
        paddingBottom: "24px"
      },
      formikButton: {
        borderRadius: 200,
        height: 48
      },
      link: {
        textDecoration: "none",
        marginTop: 32,
        paddingBottom: 8
      }
    };
  });
};
var WorkplaceLanding = function WorkplaceLanding(_ref) {
  var loading = _ref.loading,
    isError = _ref.isError,
    setEmail = _ref.setEmail,
    buttonText = _ref.buttonText,
    errorMessage = _ref.errorMessage,
    handleSubmit = _ref.handleSubmit,
    formElements = _ref.formElements,
    ValidationSchema = _ref.ValidationSchema,
    additionalFormLinks = _ref.additionalFormLinks;
  var classes = useStyles()();
  var commonClasses = useWorkplaceOSLoginStyles();
  var theme = useTheme();
  var isMobile = useMediaQuery(theme.breakpoints.down("smMd"));
  var checkForEnter = function checkForEnter(_ref2) {
    var event = _ref2.event,
      submitForm = _ref2.submitForm;
    if (event.keyCode === 13) {
      submitForm();
    }
  };
  var initialValues = _reduceInstanceProperty(formElements).call(formElements, function (obj, element) {
    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, element.id, element.initialValue));
  }, {});
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Formik, {
      validationSchema: ValidationSchema,
      initialValues: initialValues,
      onSubmit: handleSubmit,
      validateOnChange: false,
      children: function children(formikUtils) {
        var handleChange = formikUtils.handleChange,
          submitForm = formikUtils.submitForm,
          formErrors = formikUtils.errors;
        var errorCheck = _Object$keys(formErrors).length !== 0 || isError;
        return /*#__PURE__*/_jsx(Form, {
          onKeyDown: function onKeyDown(event) {
            checkForEnter({
              event: event,
              submitForm: submitForm
            });
          },
          children: /*#__PURE__*/_jsxs(WorkplaceOSLoginContainer, {
            children: [/*#__PURE__*/_jsx(WorkplaceOSLoginHeader, {
              title: "Sign in"
            }), /*#__PURE__*/_jsxs("div", {
              className: classes.containerContent,
              children: [/*#__PURE__*/_jsxs("div", {
                className: classes.containerContentItem,
                children: [errorCheck && /*#__PURE__*/_jsx(WorkplaceOSLoginError, {
                  message: errorMessage
                }), _mapInstanceProperty(formElements).call(formElements, function (element) {
                  return /*#__PURE__*/_jsxs("div", {
                    children: [/*#__PURE__*/_jsx(WorkplaceOSLoginLabel, {
                      children: element.label
                    }), /*#__PURE__*/_jsx(MuiFormikField, {
                      Component: TextField,
                      fullWidth: true,
                      name: element.id,
                      id: element.id,
                      placeholder: element.placeholder,
                      className: commonClasses.textField,
                      variant: "outlined",
                      size: "large",
                      InputProps: {
                        classes: {
                          root: commonClasses.textFieldInputRoot
                        }
                      },
                      onChange: function onChange(e) {
                        var _context;
                        e.target.value = _trimInstanceProperty(_context = e.target.value).call(_context);
                        setEmail(e.target.value);
                        handleChange(e);
                      },
                      type: element.type
                    })]
                  }, element.id);
                })]
              }), /*#__PURE__*/_jsx(RaiseButton, {
                variant: ButtonVariantEnum.primary,
                size: isMobile ? ButtonSizeEnum.medium : ButtonSizeEnum.large,
                onClick: function onClick() {
                  submitForm();
                },
                leadingIcon: loading ? IconConstants.SPINNER : undefined,
                disabled: loading,
                children: buttonText
              })]
            }), additionalFormLinks && _mapInstanceProperty(additionalFormLinks).call(additionalFormLinks, function (link) {
              return /*#__PURE__*/_jsx("div", {
                className: classes.link,
                children: /*#__PURE__*/_jsx(Link, {
                  to: link.to,
                  className: commonClasses.linkText,
                  children: /*#__PURE__*/_jsx(TextLink, {
                    children: link.label
                  })
                })
              }, link.id);
            })]
          })
        });
      }
    }), /*#__PURE__*/_jsx(WorkplaceOSLoginTerms, {})]
  });
};
export default WorkplaceLanding;